import Wrapper from "../../Wrapper";

 const VerifyOrderModification = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Verify Order Modifications</h3>
         </Wrapper>
         </>
     );
 }
 export default VerifyOrderModification;